import { AppSettingsDto } from 'src/app/services/api.services';
import { angularShortDateFormatFromPbi, getPbiDateTimeFormat } from './formatting';
import { HotCache } from './hot-cache';

export enum DateFormatType {
  Date = 'd',
  Time = 'T',
  TimeNoSeconds = 't',
  DateTime = 'dT',
  DateTimeNoSeconds = 'dt'
}

const DateFormatTypeOptions = {
  [DateFormatType.Date]: {
    formats: ['d'],
    fallback: ['L']
  },
  [DateFormatType.Time]: {
    formats: ['T'],
    fallback: ['LTS']
  },
  [DateFormatType.TimeNoSeconds]: {
    formats: ['t'],
    fallback: ['LT']
  },
  [DateFormatType.DateTime]: {
    formats: ['d', 'T'],
    fallback: ['l', 'LTS']
  },
  [DateFormatType.DateTimeNoSeconds]: {
    formats: ['d', 't'],
    fallback: ['l', 'LT']
  },
}

function convertPbiDateTimeFormatToMoment(format: string) {
  // d in moment is week day, in PBI is month day
  return format
    .replace(/dd/, 'DD')
    .replace(/d/, 'D')
    .replace(/t/, 'a')
    .replace(/tt/, 'A');
}

const cache = new HotCache<string, any>(8);

export function getMomentDateFormats(locale: string, type: DateFormatType) {
  return cache.getOrAdd([locale, type].join('.'), () => {
    let options = DateFormatTypeOptions[type];

    let splitFormat = options.formats.map((f, i) => {
      let pbiFormat = getPbiDateTimeFormat(locale, f);
      if (pbiFormat)
        return convertPbiDateTimeFormatToMoment(pbiFormat);

      return options.fallback[i];
    });

    let format = splitFormat.join(' ');

    return {
      parse: {
        dateInput: format,
      },
      display: {
        dateInput: format,
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      }
    };
  });
}

